import { MAX_CHARACTER_INPUT_VALIDATION, MAX_TEXT_INPUT_VALIDATION } from "@/constants/common";
import { PATTERN } from "@/constants/pattern";
import { dayjs } from "@/utils/dayjs";
import { validator } from "@/utils/validator";
import { isDayjs } from "dayjs";

const relatedLinkSchema = validator.object().shape({
  label: validator.string().trim().emptyToNull().max(MAX_CHARACTER_INPUT_VALIDATION).label("リンク名").notRequired(),
  url: validator
    .string()
    .trim()
    .emptyToNull()
    .max(MAX_TEXT_INPUT_VALIDATION)
    .matches(PATTERN.CUSTOM_URL, "正しいURL形式で入力してください。")
    .label("URL")
    .notRequired(),
});

const procedureSchema = validator.object().shape({
  agent: validator.string().trim().emptyToNull().isSelection().label("手続きする人").required(),
  site: validator
    .string()
    .trim()
    .emptyToNull()
    .max(MAX_CHARACTER_INPUT_VALIDATION)
    .matches(PATTERN.CUSTOM_URL, "正しいURL形式で入力してください。")
    .label("手続き先URL")
    .notRequired(),
  stepName: validator.string().trim().emptyToNull().max(MAX_CHARACTER_INPUT_VALIDATION).label("手続き表示名").required(),
  description: validator.string().trim().emptyToNull().max(MAX_TEXT_INPUT_VALIDATION).label("手続き内容の詳細説明").notRequired(),
  duration: validator.string().trim().emptyToNull().max(MAX_CHARACTER_INPUT_VALIDATION).label("手続き期間（目安）").notRequired(),
  deadline: validator.mixed().isSelection().isDayjs().label("期日").notRequired(),
});

export const examSchema = validator.object().shape({
  periodName: validator.string().trim().emptyToNull().max(MAX_CHARACTER_INPUT_VALIDATION).label("時期名").required(),
  status: validator
    .string()
    .trim()
    .emptyToNull()
    .isSelection()
    .label("ステータス")
    .required()
    .test("past-month-not-active", "過去の試験年月には「有効」ステータスを設定できません。", function (value) {
      const { examMonth } = this.parent;
      if (value === "active" && isDayjs(examMonth) && dayjs(examMonth).isBefore(dayjs(), "month")) {
        return false;
      }
      return true;
    }),
  examMethod: validator.string().trim().emptyToNull().isSelection().label("試験方式").required(),
  // 試験年月: required only when examMethod is paper_test, disabled when CBT
  examMonth: validator
    .mixed()
    .isSelection()
    .isDayjs()
    .label("試験年月")
    .when("examMethod", {
      is: "paper_test",
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
  examOverview: validator.string().trim().emptyToNull().max(MAX_TEXT_INPUT_VALIDATION).label("試験概要").notRequired(),
  examInfoSource: validator
    .string()
    .trim()
    .emptyToNull()
    .max(MAX_TEXT_INPUT_VALIDATION)
    .matches(PATTERN.CUSTOM_URL, "正しいURL形式で入力してください。")
    .label("試験情報の情報元")
    .required(),
  internalMemo: validator.string().trim().emptyToNull().max(MAX_TEXT_INPUT_VALIDATION).label("いろはな社内メモ").notRequired(),
  relatedLinks: validator.array().of(relatedLinkSchema).notRequired(),
  procedures: validator.array().of(procedureSchema).notRequired(),
  examDayDescription: validator.string().trim().emptyToNull().max(MAX_TEXT_INPUT_VALIDATION).label("試験日の詳細説明").notRequired(),
  passFailDescription: validator.string().trim().emptyToNull().max(MAX_TEXT_INPUT_VALIDATION).label("合否判定の詳細説明").notRequired(),
  announcementEstimate: validator.string().trim().emptyToNull().max(MAX_CHARACTER_INPUT_VALIDATION).label("発表目安").notRequired(),
});
